module.exports = "<h5>Bienvenue !</h5>"